import React from 'react';
import { useEffect } from "react";
import { theme, ThemeProvider, GlobalStyles } from '@octane/spark';
import { Container, Card } from './calculator.styles';
import EstimatorCard from '../estimator-card/estimator-card';
import { FontLoader } from '../font.loader';
import Disclosure from '../disclosure/disclosure';
import PrequalifiedCard from '../prequalified-card/prequalified-card';
import useEstimatorStore from '../ui/estimator-store/estimator-store';
import PropTypes from 'prop-types';

const Calculator = ({
  creditScoreSlots,
  salesPrice,
  terms,
  preselectedTerm,
  preselectedCreditScoreSlot,
  primaryAction,
  disclosure,
  cashDownPayment,
  docFee,
  themeStore,
  formula = 'standard'
}) => {
   const { setInitialParams } = useEstimatorStore();
   const calculatorTheme = themeStore?.buildSparkTheme ? themeStore.buildSparkTheme() : theme;

   useEffect(() => {
      const mainParams = {
         price: salesPrice?.price || 0,
         label: preselectedCreditScoreSlot?.label || 0,
         aprLowerBound: preselectedCreditScoreSlot?.aprLowerBound || 0,
         aprUpperBound: preselectedCreditScoreSlot?.aprUpperBound || 0,
         term: preselectedTerm || terms[0],
         cashDown: cashDownPayment || 0,
         formula: formula || 'standard',
      };

      const extraParams = {
         docFee: docFee || 0,
      };

      setInitialParams(mainParams, extraParams);
   }, [
      salesPrice,
      preselectedCreditScoreSlot,
      preselectedTerm,
      cashDownPayment,
      docFee,
      formula,
      terms,
      setInitialParams,
   ]);

  return (
    <>
      <GlobalStyles />
      <FontLoader />
      <ThemeProvider theme={calculatorTheme}>
        <Container data-testid="calculator-container">
          <Card>
            <EstimatorCard
              data-testid="estimator-card"
              creditScoreSlots={creditScoreSlots}
              salesPrice={salesPrice}
              downPayment={cashDownPayment}
              terms={terms}
              preselectedTerm={preselectedTerm}
              preselectedCreditScoreSlot={preselectedCreditScoreSlot}
              docFee={docFee}
              themeStore={themeStore}
              formula={formula}
            />
          </Card>
          <Card>
            <PrequalifiedCard
              data-testid="prequalified-card"
              primaryAction={primaryAction}
            />
          </Card>
          {disclosure && <Disclosure text={disclosure} />}
        </Container>
      </ThemeProvider>
    </>
  );
};

Calculator.propTypes = {
  themeStore: PropTypes.shape({
    buildSparkTheme: PropTypes.func,
  }),
};

export default Calculator;
